import { ProfileRole } from "@veris-health/user-ms/lib/v1";

export const checkUserRoles = (rolesToCheck: string[], userRoles?: ProfileRole[]): boolean => {
  return !!userRoles && rolesToCheck.some((role) => userRoles.some((r) => r.role_name === role));
};
